import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../shared/providers/validation.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { LoaderService } from '../shared/providers/loader.service';
import { UserExchangeModel } from '../shared/models/UserExchangesModel';
import { BrokerSelecttionModel } from '../shared/models/SavePropertyInputModel';
import { SelectedIdInputmodel } from '../shared/models/SelectedIdInputmodel';
import { SavePropertyContactUserInput } from '../shared/models/SavePropertyContactUserInput';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { UserAssociatedProperties } from '../shared/models/UserAssociatedProperties';
import { IUser } from '../shared/models/user';
import { IUserDetails } from '../shared/models/UserDetailsOutputModel';
import { UserRole } from '../shared/enum/enum';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { RestService } from '../shared/providers/rest.service';
import { IDataEntryStaffPropertyOutputList } from '../shared/models/DataEntryStaffPropertyListOutputModel';
import { DESAssociationModel } from '../shared/models/DesAssociationModel';

@Component({
  selector: 'des-associations',
  templateUrl: './des-associations.component.html',

})

export class DESAssociationsComponent {
  constructor(private _userManagerService: UserManagerService, private rest: RestService, private activatedRoute: ActivatedRoute, private Loader: LoaderService, private http: HttpClient, public authService: AuthenticationService, private router: Router, public _validationService: ValidationService, private _propertyManagementService: PropertyManagementService) {

  }
  user: any;
  @Input() CurrentUser = {} as IUser;
  @Input() principalDetails = {} as IUserDetails;

  protected readonly BASE_URL: string = environment.base_url;
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dtoptions = {};
  DDColumns = [];
  propertyList: DESAssociationModel[];
  selectAll = false;
  IsEditClicked = false;
  brokers: BrokerSelecttionModel[] = [];
  selectedInputModel: SelectedIdInputmodel[] = [];
  propertyContactInput = {} as SavePropertyContactUserInput;
  selectedLiveListings: UserExchangeModel[] = [];
  ngOnInit() {
    this.user = this.authService.user;
    this.getExchanges();
  }

  bindBrokers() {
    this._propertyManagementService.getBrokers(0).subscribe(response => {
      this.brokers = response;
    });
  }

  propertyStatusList: ILookUp[];
  brokerageId: number = 0;
  getExchanges() {
    if (localStorage.getItem("brokerageId") != null) {
      var brokerageId = parseInt(localStorage.getItem("brokerageId"));
      this.brokerageId = brokerageId;
    }
    else {
      this.brokerageId = 0;
    }
    this.dtoptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      "pageLength": 50,
      stateSave: true,
      stateSaveCallback: function (settings, data) {
        localStorage.setItem("DataTables_property_dataEntryStaff_list_view", JSON.stringify(data));
      },
      stateLoadCallback: function (settings) {
        $(".dataTables_paginate.paging_full_numbers").show();
        return JSON.parse(localStorage.getItem("DataTables_property_dataEntryStaff_list_view"));
      },
      "order": [[0, "desc"]],
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {

        const filter =
        {
          //StatusId: that.propertyStatusId,
          BrokerageId: this.brokerageId,
          PropertyTypeId: 6856
        }

        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.rest.GetAuthHeader();
        this.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/property/dataEntryStaffAssociation/' + this.user.Id ,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            this.propertyList = resp.data ? resp.data : [];
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp?.data?.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          });
      },
      columns: [
        { data: 'PropertyName' },
        { data: 'PropertyStatus' },
        { data: 'Price' },
        { data: 'BrokerageName' },
       ]
    };
  }
}
